import Vue from 'vue';
import VueSeo from './vue-seo-plugin';

export default ({ app }) => {
    Vue.use(VueSeo, app.i18n, app.$gql);
};
